module.exports = __webpack_public_path__ + "img/21600.524c46e3.jpg";